'use client';

import { useTranslations } from 'next-intl';

import { Box, Paper, Typography } from '@mui/material';

import { Markdown } from '../../../../../../components/markdown/Markdown';
import { checkPartnerName } from '../../../../../../utils/partner/partner.util';

export const InfoBox = () => {
  const t = useTranslations();
  const partnerName = checkPartnerName();

  return (
    <Paper sx={{ p: { xs: 2, md: 4 }, height: '100%' }}>
      <Typography variant="h6">{t(`headers.infoBoxHeader.${partnerName}`)}</Typography>
      <Box sx={{ '&>p': { mb: 4 } }}>
        <Markdown>{t(`text.infoBoxDesc.${partnerName}`)}</Markdown>
      </Box>
    </Paper>
  );
};
